import {useCan} from '@/shared/hooks/use-permissions'
import {PatientTherapySequenceStatus} from '@cypro/engine/database/schema'
import {PatientTherapySequenceEventType} from '@cypro/engine/mutators'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useFormatTherapySequenceLabel(sequence: PatientTherapySequence) {
  const {t} = useTranslate('activity')
  const {t: tCommon} = useTranslate('common')
  const canValidateAsDoctor = useCan('prescriptions.validate_doctor')

  const format = useCallback(
    (key: string, part: 'title' | 'description' | 'action') => {
      const isSmartCompounder = Boolean(sequence.compoundedByMachine)
      const prefix =
        isSmartCompounder && sequence.status === PatientTherapySequenceStatus.enum.in_production
          ? 'smart-compounder.'
          : ''

      if (part === 'action') {
        // doctors "Edit", pharmacists "Review" — the same REVISE action
        if (key === PatientTherapySequenceEventType.enum.REVISE && canValidateAsDoctor) return tCommon('edit')
        // rejecting at QA and sending back from the ward have specific wording
        if (key === PatientTherapySequenceEventType.enum.SPOILAGE) return tCommon('reject')
        if (
          key === PatientTherapySequenceEventType.enum.RETURN_TO_PHARMACY &&
          (sequence.status === PatientTherapySequenceStatus.enum.released_for_delivery ||
            sequence.status === PatientTherapySequenceStatus.enum.administration)
        ) {
          return tCommon('not_administered')
        }

        return t(`actions.${prefix}${key}`)
      }

      return t(`${key}.${prefix}${part}`)
    },
    [t, tCommon, sequence, canValidateAsDoctor]
  )

  return format
}
